import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EntitiesService {

    private http = inject(HttpClient);

    constructor() { }

    get(): Observable<any> {
        return this.http.get(Global.url + 'V1/entities').pipe(
            map((data: any) => data.map((item: any) => ({
                ...item,
                label: item.isActive === false
                    ? `${item.code} - ${item.name} (inactiva)`
                    : `${item.code} - ${item.name}`
            })))
        );
    }

    getById(id: any): Observable<any> {
        return this.http.get(Global.url + 'V1/entities/' + id);
    }
}
